import CircularLoader from 'components/CircularLoader';

const InvoiceLoader = () => (
    <div className="flex h-[400px] w-full items-center justify-center">
        <CircularLoader className="static size-auto" />
    </div>
);

export default InvoiceLoader;
